package org.example.site_web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSColor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.example.site_web.aiPalette
import org.example.site_web.components.images.AccTriangleIcon
import org.example.site_web.components.layouts.PageLayoutData
import org.example.site_web.content.page.projectContent_Part1
import org.example.site_web.content.page.projectContent_Part2
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text


val projectParaphStyle = CssStyle {
    base {
        Modifier
            .borderLeft {
                color(aiPalette.mainPalette.primary)
                style(LineStyle.Solid)
                width(0.5.cssRem)
            }
            .padding(left = 0.5.cssRem)
            .margin(topBottom = 1.5.cssRem)
    }
}

@InitRoute
fun initProjectsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Nos Projets"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun ProjectsPage() {

    Column(
        offersPageStyle.toModifier(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.SpaceAround
    ) {

        Box(
            Modifier
                .fillMaxWidth()
                .fontSize(2.0.cssRem)
                .fontWeight(FontWeight.Bold)
                .margin(top = 1.5.cssRem),
            contentAlignment = Alignment.BottomStart
        ) {
            Span() {
                AccTriangleIcon()
                Text("Nos Projets")
            }
        }

        Box(
            projectParaphStyle.toModifier()
                .fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier
                    .textAlign(TextAlign.Left).toAttrs()
            ) {
                Text(projectContent_Part1)
            }
        }

        Row(
            Modifier
                .margin(left = 3.cssRem)
                .fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(1.5.cssRem)
        ) {
            Link(path = "https://lorient-technopole.fr/") {
                Img(
                    src = "/assets/pics/oursupports/technopole.svg",
                    attrs = Modifier.height(4.em).toAttrs()
                )
            }
            Link(path = "https://www.bretagne.bzh/aides/fiches/emergys-bretagne/") {
                Img(
                    src = "/assets/pics/oursupports/logo_bzh_acc.png",
                    attrs = Modifier.height(4.em).toAttrs()
                )
            }
        }

        Box(
            projectParaphStyle.toModifier()
                .fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(
                Modifier
                    .textAlign(TextAlign.Left).toAttrs()
            ) {
                Text(projectContent_Part2)
            }
        }

        Spacer()
    }
}
